import {
  Box,
  Center,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  UseDisclosureReturn,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { BadgeArgs, BADGE_CRITERIA } from '../common/libs/badgeType';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';
import { createSelfProfileUrl } from '../common/libs/user';
import BadgeIcon from './BadgeIcon';

export default function AchievedBadgeModal({
  badge,
  onClose,
  disclosure,
}: {
  badge?: BadgeArgs;
  onClose?: () => void;
  disclosure: UseDisclosureReturn;
}) {
  const [badgeTitle, setBadgeTitle] = useState('');
  const [badgeViewUrl, setBadgeViewUrl] = useState('');
  useEffect(() => {
    if (badge) {
      const badgeTypeConf = BADGE_CRITERIA[badge.seriesId][badge.typeId];
      const badgeName =
        badgeTypeConf!.badges[badge.grade]!.label ||
        `${BADGE_CRITERIA[badge.seriesId][badge.typeId].label}${
          badgeTypeConf!.badges[badge.grade]!.threshold
        }回`;
      setBadgeTitle(badgeName || '');

      const badgeViewUrl = createSelfProfileUrl({
        defaultIsOpenBadgeModal: true,
      });
      setBadgeViewUrl(badgeViewUrl);
    }
  }, [badge]);

  return (
    <Modal
      size={'lg'}
      onClose={() => {
        disclosure.onClose();
        if (onClose) {
          onClose();
        }
      }}
      isOpen={disclosure.isOpen}
    >
      <Box pos="relative">
        <ModalOverlay />
        <ModalContent pos={'absolute'} right={[null, null, 10]}>
          <ModalHeader>
            <Center mt={4}>
              <Text fontSize={'xl'} fontWeight={'bold'} color={'#968751'}>
                Antaaからのお知らせ
              </Text>
            </Center>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody mt={-4} mb={10}>
            <Box textAlign="center">
              {!!badge && (
                <>
                  <BadgeIcon
                    seriesId={badge.seriesId}
                    typeId={badge.typeId}
                    grade={badge.grade}
                    achieved
                    width={'180px'}
                    height={'159px'}
                  />
                  <Text
                    fontSize={'lg'}
                    fontWeight={'bold'}
                    align={'center'}
                    marginTop={8}
                    color={'black'}
                  >
                    おめでとうございます
                    <br />「{badgeTitle}」
                    <Link
                      href={badgeViewUrl}
                      onClick={() =>
                        sendAnalyticsEvent(
                          'badge',
                          'show',
                          'list_from_achieved',
                        )
                      }
                    >
                      バッジ
                    </Link>
                    を獲得しました
                  </Text>
                </>
              )}
            </Box>
          </ModalBody>
        </ModalContent>
      </Box>
    </Modal>
  );
}
